module.exports = __webpack_public_path__ + "src/assets/games/9/39.jpg";